import { render, staticRenderFns } from "./OrderFilingTaxGroup.vue?vue&type=template&id=45044c76&scoped=true"
import script from "./OrderFilingTaxGroup.vue?vue&type=script&lang=js"
export * from "./OrderFilingTaxGroup.vue?vue&type=script&lang=js"
import style0 from "./OrderFilingTaxGroup.vue?vue&type=style&index=0&id=45044c76&prod&scoped=true&lang=css"
import style1 from "./OrderFilingTaxGroup.vue?vue&type=style&index=1&id=45044c76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45044c76",
  null
  
)

export default component.exports